export default {
  // B端业务菜单 - 一级菜单
  'menu.roomStatus': '房态',
  'menu.roomPrice': '房价',
  'menu.order': '订单',
  'menu.checkin': '入住',
  'menu.finance': '财务',
  'menu.customer': '客户',
  'menu.review': '评价',
  'menu.cleaning': '保洁',
  'menu.direct': '直连',

  // B端业务菜单 - 直连二级菜单
  'menu.direct.channelAccount': '平台账号',
  'menu.direct.channelProduct': '房源关联',

  // B端业务菜单 - 订单二级菜单
  'menu.order.individual': '散客单',
  'menu.order.group': '团队单',
  'menu.order.contract': '协议单',

  // B端业务菜单 - 入住二级菜单
  'menu.checkin.management': '入住管理',
  'menu.checkin.deposit': '押金管理',

  // B端业务菜单 - 财务二级菜单
  'menu.finance.report': '销况',

  // B端业务菜单 - 客户二级菜单（分组模式）
  'menu.customer.normal': '普通客户',
  'menu.customer.normal.list': '客户列表',

  // B端业务菜单 - 评价二级菜单
  'menu.review.comment': '评价管理',

  // B端业务菜单 - 保洁二级菜单
  'menu.cleaning.task': '任务列表',
  'menu.cleaning.stat': '任务统计',
  'menu.cleaning.cleaner': '保洁员',

  // 默认菜单
  'menu.welcome': '欢迎',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.account.logout': '退出登录',
};
